import Iconify from 'src/components/iconify';

export const DocPinIcon = ({ isOnActionBar }: { isOnActionBar: boolean }) => {
  return (
    <Iconify
      icon={isOnActionBar ? 'tabler:pinned-filled' : 'tabler:pinned'}
      color={(theme) =>
        isOnActionBar ? theme.palette.primary.main : 'primary'
      }
    />
  );
};
